module.exports = __webpack_public_path__ + "static/media/logo-cbc-outline.fd831e07.svg";